import { render, staticRenderFns } from "./barcodesoutStorageHistory.vue?vue&type=template&id=6fd8b6f1&scoped=true&"
import script from "./barcodesoutStorageHistory.vue?vue&type=script&lang=js&"
export * from "./barcodesoutStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./barcodesoutStorageHistory.vue?vue&type=style&index=0&id=6fd8b6f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd8b6f1",
  null
  
)

export default component.exports